export enum TRAINING_DIRECTION {
	FROM_FOREIGN = 0,
	FROM_MY = 1,
	RANDOM = 2
}
